import { HttpClient } from '../HttpClient';
/**
 * * Get single month statement
 **/

export const GetStatement = async (id) => {
  try {
    const response = await HttpClient.get(`/api/instacash/statements/${id}`);
    return await Promise.resolve(response);
  } catch (err) {
    return Promise.reject(err);
  }
};
